import { ComponentChildren, Ref, JSX } from 'preact';
import cn from 'classnames';

import { ButtonUnstyled } from '../ButtonUnstyled/ButtonUnstyled';

export type BaseButtonProps<T extends keyof JSX.IntrinsicElements = 'button'> =
  {
    component?: T;
    children?: ComponentChildren;
    buttonRef?: Ref<HTMLElement>;
    className?: Exclude<
      JSX.IntrinsicElements[T]['className'],
      JSX.SignalLike<any>
    >;
  } & Omit<JSX.IntrinsicElements[T], 'color' | 'size' | 'className'>;

export const BaseButton = <T extends keyof JSX.IntrinsicElements = 'button'>({
  children,
  buttonRef,
  className,
  ...props
}: BaseButtonProps<T>) => {
  return (
    // @ts-expect-error typescript's gone mad
    <ButtonUnstyled
      className={cn('vgp-base-button', className)}
      ref={buttonRef}
      {...props}
    >
      {children}
    </ButtonUnstyled>
  );
};
